<template>
	<div>
		<van-button type="default" @click="logOut()">退出登录</van-button>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		methods:{
			logOut(){
				localStorage.removeItem('userId');
				localStorage.removeItem('token');
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/personal/logout.vue